import type {
  AxiosInstance,
  AxiosPromise,
  AxiosRequestConfig,
} from 'axios';
import { camelCase } from 'change-case';

import { caseConverter } from '@/utils/case-converter';

export class AlternateRequest {
  private instance!: AxiosInstance;

  constructor() {
    this.initConfig();
  }

  async initConfig() {
    const axios = (await import('axios')).default;

    this.instance = axios.create({
      baseURL: process.env.REACT_APP_ACTION_CENTER_ROOT && `${process.env.REACT_APP_ACTION_CENTER_ROOT}/`.replace(/\/\/$/, '/'),
    });

    this.instance.interceptors.response.use(response => ({
      ...response,
      data: caseConverter(response.data, camelCase),
    }), async error => Promise.reject(error));
  }

  get<P, QP = unknown>(
    url: string,
    config?: AxiosRequestConfig & { params?: QP }
  ): AxiosPromise<P> {
    return this.instance.get(url, config);
  }
}

export const alternateRequest = new AlternateRequest();
